import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import type { Sync } from 'modules/payroll_integrations_datev_lauds/lib/IncidenceSync/store'

interface Props {
  onSync: () => void
  syncing: boolean

  submitButton: string
  sync: Sync
}

const Blocked = ({ onSync, syncing, submitButton, sync }: Props) => {
  const Content = ({ title, description }: { title: string; description: string }) => {
    return (
      <>
        <Box gap="s4" flexDirection="row">
          <Icon.Medium icon="alert-circle-line" color="radicalRed1000" />
          <Text.Header2>{title}</Text.Header2>
        </Box>
        <Box>{description}</Box>
      </>
    )
  }

  const getContent = () => {
    switch (sync.error_code) {
      case '#DXLO02413':
        return (
          <Content
            title={i18n.t(
              'payroll_integrations.incidences.datev_lauds.hiring.error.employee_code_title'
            )}
            description={i18n.t(
              'payroll_integrations.incidences.datev_lauds.hiring.error.employee_code_message'
            )}
          />
        )
      case '#DCO02404':
      case '#DCO02402':
        return (
          <Content
            title={i18n.t(
              'payroll_integrations.incidences.datev_lauds.hiring.error.consultant_client_code_title'
            )}
            description={i18n.t(
              'payroll_integrations.incidences.datev_lauds.hiring.error.consultant_client_code_message'
            )}
          />
        )
      case '#DCO02401':
      case '#DCO02440':
        return (
          <Content
            title={i18n.t(
              'payroll_integrations.incidences.datev_lauds.hiring.error.tax_advisor_title'
            )}
            description={i18n.t(
              'payroll_integrations.incidences.datev_lauds.hiring.error.tax_advisor_message'
            )}
          />
        )
      default:
        return (
          <Content
            title={i18n.t('payroll_integrations.incidences.datev_lauds.hiring.error.title')}
            description={i18n.t(
              'payroll_integrations.incidences.datev_lauds.hiring.error.generic_error_message'
            )}
          />
        )
    }
  }

  return (
    <>
      {getContent()}
      <Button onClick={onSync} disabled={syncing} type="secondary">
        {submitButton}
      </Button>
    </>
  )
}

export default Blocked
